import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import XYSettingDialog, { XYSettingDialogResponse } from '../../molecules/Dialog/XYSettingDialog';
import { useModal } from '../../../function/useModal';
import { XY_CMP_GROUP_SET, GetXYComparisonGroupList } from '../../../function/GroupDataModel';

import { SpeedKind, MeasureLowKind, MeasureHighKind } from '../../../Constant';

import { MeasureInfoType, GetMeasureInfoType, SelectDataType, IsValidKindOfXyCmp, GetXYDiagramData, XYDiagramSettingModel } from './XYDiagram';
import XYDiagramSelectItem from './XYDiagramSelectItem';
import XYDiagramChart from './XYDiagramChart';
import XYDiagramButtonList from './XYDiagramButtonList';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 350px)',
      maxHeight: 'calc(100vh - 350px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      width: '100px',
      maxHeight: '35px',
      minHeight: '35px',
      marginLeft: '40px',
      alignItems: 'center',
    },
  })
);

const getDevalutXid = (meslist: MeasureInfoType[]): number => {
  var defX = meslist.find((row) => row.Speed === SpeedKind.SPEED_KIND_HIGHT);
  if (defX) {
    return defX.id;
  } else {
    return 1;
  }
};

const getDevalutYid = (meslist: MeasureInfoType[]): number => {
  var defY = meslist.find((row) => row.Speed === SpeedKind.SPEED_KIND_LOW);
  if (defY) {
    return defY.id;
  } else {
    return 1;
  }
};

const CreateSelectData = (
  meslist: MeasureInfoType[],
  orgDt: SelectDataType,
  xDt?: MeasureInfoType,
  yDt?: MeasureInfoType
): SelectDataType => {
  var fDevList = meslist.filter((output) => {
    return IsValidKindOfXyCmp(output.Speed, output.KindNo);
  });
  var xid = getDevalutXid(fDevList);
  var yid = getDevalutYid(fDevList);

  orgDt.devid = 1;

  orgDt.xid = xid;
  orgDt.yid = yid;

  var devList = fDevList.filter(
    (el: MeasureInfoType, index, self) => self.findIndex((e: MeasureInfoType) => e.DevIndex === el.DevIndex) === index
  );

  var searchDevIndex: number = 1;
  if (xDt != undefined) {
    searchDevIndex = xDt.DevIndex;
  }
  var dev = devList.find((row) => row.DevIndex === searchDevIndex);
  orgDt.devid = dev != undefined ? dev.id : orgDt.devid;

  var xyList = fDevList.filter((output) => {
    return output.DevIndex == dev?.DevIndex && IsValidKindOfXyCmp(output.Speed, output.KindNo);
  });

  if (xDt != undefined) {
    var xValue = xyList.find(
      (row) => row.DevIndex === xDt.DevIndex && row.KindNo == xDt.KindNo && row.ItemNameNo == xDt.ItemNameNo
    );
    orgDt.xid = xValue != undefined ? xValue.id : getDevalutXid(xyList);
  }

  if (yDt != undefined) {
    var yValue = xyList.find(
      (row) => row.DevIndex === yDt.DevIndex && row.KindNo == yDt.KindNo && row.ItemNameNo == yDt.ItemNameNo
    );
    orgDt.yid = yValue != undefined ? yValue.id : getDevalutYid(xyList);
  }

  return orgDt;
};

type Props = {
  location: { state: XY_CMP_GROUP_SET };
};

const XYDiagramPage: React.FC<Props> = (props) => {
  //console.debug(['XYDiagramPage()', props]);
  const { t } = useTranslation();
  const classes = useStyles();
  const yesterDay: Date = dayjs(new Date()).subtract(1, 'day').toDate();
  const [loading, setLoading] = React.useState(false);
  const [chartUpdate, setChartUpdate] = React.useState<string>('');
  const [measureInfo, setMeasereInfo] = React.useState<MeasureInfoType[]>([]);
  const [selectData, setSelectData] = React.useState<SelectDataType>({
    devid: 0,
    xid: 0,
    yid: 0,
    //うるう年考慮
    fromDay: dayjs(yesterDay).subtract(1, 'year').add(1, 'day').toDate(),
    toDay: yesterDay,
  });
  const [xyCmpGroupSet, SetXyCmpGroupSet] = React.useState<XY_CMP_GROUP_SET>(props.location.state);
  const [selectSettingFlg, setSelectSettingFlg] = React.useState<boolean>(false);

  const [xyDiagramSetting, setXyDiagramSetting] = React.useState<XYDiagramSettingModel>({
    GraphDataItems: [],
    YearFlg: 0,
    MonthFlg: 0
  });

  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = React.useState<string>('');

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
  const [flgXYDlg, actXYDlg] = useModal<XYSettingDialogResponse>();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getMeasurInfoData();
  }, []);

  /**
   * デバイス情報を取得
   */
  const getMeasurInfoData = () => {
    GetMeasureInfoType().then((mesRet) => {
      for (var i in mesRet) {
        mesRet[i].id = Number(i + 1);
      }

      var s1: SelectDataType = {
        devid: 1,
        xid: 1,
        yid: 1,
        fromDay: dayjs(yesterDay).subtract(1, 'year').add(1, 'day').toDate(),
        toDay: yesterDay,
      };
      if (props.location.state) {
        var gp = props.location.state;
        console.debug(['XYInit - param ', gp]);
        var xdt = mesRet.find((item) => item.PlcNo == gp.PLC_NO_X && item.SetNo == gp.SET_NO_X);
        var ydt = mesRet.find((item) => item.PlcNo == gp.PLC_NO_Y && item.SetNo == gp.SET_NO_Y);

        s1 = CreateSelectData(mesRet, s1, xdt, ydt);
        console.debug(['XYInit', mesRet, s1, xdt, ydt]);

        if (xdt === undefined || ydt === undefined) {
          setDlgmsg(t('XYDiagramPage.指定したデータが見つかりませんでした', '指定したデータが見つかりませんでした'));
          console.warn(['data find error   ', gp]);
          actMsgDlg.open();
        } else {
          setSelectData(s1);
          //setMeasereInfo(mesRet);
          //XYのグループ設定読込み
          if (isOpen) {
            //設定でグループ内容更新時に使用
            GetXYComparisonGroupList().then((ret) => {
              var fillter = ret.XY_CMP_GROUP_SETs.filter((item) => item.GROUP_NO == gp.GROUP_NO);
              console.debug(['Groupitems chenge', fillter, ret]);
              SetXyCmpGroupSet(fillter[0]);

              xdt = mesRet.find((item) => item.PlcNo == fillter[0].PLC_NO_X && item.SetNo == fillter[0].SET_NO_X)
              ydt = mesRet.find((item) => item.PlcNo == fillter[0].PLC_NO_Y && item.SetNo == fillter[0].SET_NO_Y);
              s1 = CreateSelectData(mesRet, s1, xdt, ydt);
              setSelectData(
                s1
              )
            }).finally(() => {
              console.debug(['Groupitems chenge2', selectData]);
              setMeasereInfo(mesRet);
              setSelectSettingFlg(true);
            })
          }
          else {
            //初期読込み
            SetXyCmpGroupSet(gp);
            setMeasereInfo(mesRet);
          }
          //年・月設定とグラフデータ取得
          getXYDiagrams(mesRet, s1);
          setIsOpen(false);
        }
      } else {
        setMeasereInfo(mesRet);
        setIsOpen(false);
      }
    });
  }

  /**
   * 年・月設定とグラフデータ取得処理
   * @param mesInfo 
   * @returns 
   */
  const getXYDiagrams = (mesInfo: MeasureInfoType[], s1: SelectDataType) => {
    console.debug(["getXYDiagrams mesInfo", mesInfo]);
    if (mesInfo.length === 0) {
      console.debug(["getXYDiagrams mesInfo empty"]);
      return;
    }
    var x = mesInfo.find((item) => item.id === s1.xid);
    var y = mesInfo.find((item) => item.id === s1.yid);

    if (x == null || y == null) {
      console.debug(["getXYDiagrams x or y null"]);
      return;
    }
    //年・月設定とグラフデータ取得
    GetXYDiagramData(xyCmpGroupSet.GROUP_NO, x.PlcNo, x.SetNo, x.Speed,
      x.KindNo, y.PlcNo, y.SetNo, y.Speed, y.KindNo, s1.fromDay, s1.toDay).then((xyDiagram) => {
        if (xyDiagram !== undefined) {
          setXyDiagramSetting(xyDiagram);
        }
        setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
        console.debug(["getXYDiagrams check", xyDiagram]);
      });
  }

  /**
   * 機器設定変更
   * @param target 
   */
  const onChangeSelectData = (target: SelectDataType) => {
    console.debug(["--onChangeSelectData-- select", target]);
    setSelectData({ ...target });
  };

  /**
   * 表示ボタンクリック
   */
  const onClickDisplayButton = () => {
    console.debug(["--onClickDisplayButton-- click", selectData, measureInfo]);
    let measureInfoRow = measureInfo.find((r) => r.id == selectData.devid)
    if (measureInfoRow != undefined) {
      var x = measureInfo.find((item) => item.id === selectData.xid);
      var y = measureInfo.find((item) => item.id === selectData.yid);

      if (x == null || y == null) {
        console.debug(["getXYDiagrams x or y null"]);
        return;
      }

      /**グラフ更新 */
      console.debug([`--onClickDisplayButton-- items GROUP:${xyCmpGroupSet.GROUP_NO},PLC_NO:${measureInfoRow.PlcNo},x.SetNo:${x.SetNo},` +
        `x.Speed:${x.Speed},x.KindNo:${x.KindNo},y.SetNo:${y.SetNo},y.Speed:${y.Speed},y.KindNo:${y.KindNo}`]);
      GetXYDiagramData(xyCmpGroupSet.GROUP_NO, measureInfoRow.PlcNo, x.SetNo, x.Speed,
        x.KindNo, measureInfoRow.PlcNo, y.SetNo, y.Speed, y.KindNo, selectData.fromDay, selectData.toDay).then((xyDiagram) => {
          if (xyDiagram !== undefined) {
            setXyDiagramSetting(xyDiagram);
          }
          setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
          console.debug(["onClickDisplayButton check", xyDiagram])

        });
    }
  };

  //グループ設定ダイアログ操作
  useEffect(() => {
    //console.debug(["isOpen check", isOpen]);
    if (isOpen) {
      console.debug(["isOpen ok"]);
      actXYDlg
        .open()
        .apply((_) => {
          console.debug(["showXYSettingDiaog"]);
          getMeasurInfoData();
        })
        .cancel((_) => {
          console.debug(["showXYSettingDiaog cancel"]);

          setIsOpen(false);
        });
    }
  }, [isOpen])

  /**
   * 設定ボタンクリック
   */
  const showXYSettingDiaog = () => {
    setIsOpen(true)
  };

  /**
   * 設定更新処理
   * @param target 
   */
  const onChangeSettingData = (target: boolean) => {
    console.debug(["--onChangeSettingData--", target]);
    if (!target) {
      setSelectSettingFlg(target);
      onClickDisplayButton();
    }
  };

  //グループ設定画面表示
  const xydlg = flgXYDlg ? <XYSettingDialog dialog={actXYDlg} groupNo={xyCmpGroupSet.GROUP_NO} /> : null;


  const handleLoadingStateChange = (value: boolean): void => setLoading(value);

  //console.debug(['- 画面描画開始 -', measureInfo, selectData]);
  return (
    <>
      <Box display="flex" justifyContent="flex-start" alignItems="center"></Box>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center">
        {/**グラフの上の機器設定箇所 */}
        <Grid item xs={9}>
          <XYDiagramSelectItem
            mesInfoList={measureInfo}
            selectData={selectData}
            xyDiagramSettingModel={xyDiagramSetting}
            xyCmpGroupSet={xyCmpGroupSet}
            changeSelectFlg={selectSettingFlg}
            onChangeSelectDataEvent={onChangeSelectData}
            onChangeSelectFlg={onChangeSettingData}
          />
        </Grid>
        {/**表示ボタン */}
        <Grid item xs={2} container justify="flex-end">
          <LoadingButton
            className={classes.buttonStyle}
            loading={loading}
            loadingPosition="start"
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={onClickDisplayButton}
          >
            {t('XYDiagramPage.表示', '表示')}
          </LoadingButton>
          {/**設定ボタン */}
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={showXYSettingDiaog}
          >
            {t('XYDiagramPage.設定', '設定')}
          </Button>
        </Grid>
        {/**グラフ表示 */}
        <Grid item xs={12}>
          <XYDiagramChart
            update={chartUpdate}
            chartContainerStyle={classes.responsiveContainer}
            selectData={selectData}
            groupNo={xyCmpGroupSet.GROUP_NO}
            mesInfoList={measureInfo}
            updateLoadginState={handleLoadingStateChange}
            xyDiagramSettingModel={xyDiagramSetting}
          />
        </Grid>
        <Grid item xs={12}>
          <XYDiagramButtonList selectData={selectData} measureInfo={measureInfo} />
        </Grid>
      </Grid>
      {msgdlg}
      {xydlg}
    </>
  );
};

export default XYDiagramPage;
